import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const imobApiInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req.clone({
    setHeaders: {
      Authorization: localStorage.getItem('token') || ''
    }
  })).pipe(
    catchError((err: Error) => {
      console.error(err);
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          localStorage.clear();
          router.navigate(['login']);
        }
      }
      return throwError(() => err);
    })
  );
};
